export default value => {
  if (value === 'ACTIVE') {
    return 'Active';
  } if (value === 'SOLD_OUT') {
    return 'Sold out';
  } return 'Deactivated';
};
